import { render, staticRenderFns } from "./Future.vue?vue&type=template&id=294c0364&scoped=true"
import script from "./Future.vue?vue&type=script&lang=js"
export * from "./Future.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "294c0364",
  null
  
)

export default component.exports